import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useState } from 'react';
import { login } from '../../api/api';
import {useNavigate} from 'react-router-dom';

function LoginModal(props) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleRegister = (event) => {
        event.preventDefault();
        props.setShow(false);
        props.setShowRegister(true);
    };

    const handlePasswordReset = (event) => {
        event.preventDefault();
        props.setShow(false);
        props.setShowRequestPasswordResetModal(true);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        login(email, password).then(loginData => {
            props.setToken(loginData.token);
            props.setShow(false);
            if (props.nextPage) {
                const nextPage = props.nextPage;
                props.setNextPage('');
                navigate(nextPage);
            }
        }).catch(() => {
            props.setShow(false);
        });
    };

    return (
        <Modal show={props.show} onHide={() => props.setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Login</Modal.Title>
            </Modal.Header>

            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="loginForm.Email">
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" onChange={(e) => setEmail(e.target.value)} />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="loginForm.Password">
                        <Form.Label>Password</Form.Label>
                        <Form.Control type="password" onChange={(e) => setPassword(e.target.value)} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <a href="#id" onClick={handleRegister}>Need an Account?</a>
                    <a href="#forgotpassword" onClick={handlePasswordReset}>Forgot Password?</a>
                    <Button variant="secondary" className="ms-auto" onClick={() => props.setShow(false)}>Cancel</Button>
                    <Button variant="primary" type="submit" onClick={handleSubmit}>Login</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default LoginModal;